module.exports = __webpack_public_path__ + "static/media/ice42.4ed32f98.webp";